import React, { useState } from "react";
import "./styles.scss";
import closeIcon from "../../assets/icons/x-circle.svg"

type Tprop = {
    setShow: (open: boolean) => void
    handleDeleteItem: any

}

type T2prop = {
    setShow: any
    status:string
    handleClose?: any
}

type T3prop = {
    state:string
    setShow: (open: boolean) => void
    handleAdd?: any
    handleEditItem?:any
    editData?:any

}

//delete

export const FAQDialogBox: React.FC<Tprop> = ({ setShow, handleDeleteItem }) => {
    const message3 = "Do you want to delete the FAQ?"
    const [result, setResult] = useState<boolean>(false)

    const handleClose = () => {
        setShow(false)
        handleDeleteItem("yes")
    }

    return (
        <div className="faqdialog-box">
            <div className="box">
                <div className="close">
                    <div className="dialog-btn-close" onClick={() => setShow(false)}>
                        <img src={closeIcon} alt="not-found" />
                    </div>
                </div>
                <p className="text"> {message3}
                </p>
                <div className="faq-btn">
                    <div className="dialog-btn" onClick={() => {
                        setResult(true)
                    }}>Yes</div>
                    <div className="dialog-btn" onClick={() => setShow(false)}>No</div>
                </div>
            </div>
            {result && <FAQDialogBoxResult status={"delete"} setShow={setResult} handleClose={handleClose} />}
        </div>
    );
};

//result for delete

export const FAQDialogBoxResult: React.FC<T2prop> = ({ status, setShow ,handleClose}) => {

    const message1 = "The FAQ has been deleted successfully"
    const message2 = "FAQ has been added successfully"
    const message3 = "FAQ has been updated successfully"

    return (
        <div className="dialog-box">
            <div className="box result">
                <div className="close">
                    <div className="dialog-btn-close" onClick={() => {
                        setShow(false)
                        handleClose()
                    }
                    }>
                        <img src={closeIcon} alt="not-found" />
                    </div>
                </div>
                <p className="text"> {status==="add"?message2:status==="delete"?message1: status==="edit"?message3:"Something Went Wrong"}
                </p>
                <div className="faq-btn">
                    <div className="dialog-btn" onClick={() => {
                        setShow(false)
                        handleClose()
                    }}>OK</div>
                </div>
            </div>

        </div>
    );
};

//add & edit

export const FAQAddDialogBox: React.FC<T3prop> = ({state, setShow, handleAdd,handleEditItem,editData }) => {

    const message1 = "Please enter the Question and Answer"
    const message2 = "Please update the Question and Answer"

    const onSubmit = () => {
        if(state==="edit"){
            //handleEditItem()
            setShow(false)
        }
        else{
            //handleAdd(data)
            setShow(false)
        }

    }

    return (
        <div className="dialog-box">
            <div className="box add-box">
                <div className="close add-close">
                    <p className="add-heading"> {state==="edit"? message2:message1}
                    </p>
                    <div className="dialog-btn-close" onClick={() => setShow(false)}>
                        <img src={closeIcon} alt="not-found" />
                    </div>

                </div>
                <form onSubmit={onSubmit} style={{width:"100%"}}>
                    <div className="add-form" >
                        <div className="add-form-field">
                            <p className="add-form-label"> Question:
                            </p>
                            <input  defaultValue={state==="edit"?editData.title:""} className="add-form-input" type="text" />
                        </div>
                        <div className="add-form-field">
                            <p className="add-form-label"> Answers:
                            </p>
                            <input  defaultValue={state==="edit"?editData.description:""} className="add-form-input" type="textarea" />
                        </div>

                    </div>
                    <div className="faq-btn add-btn">
                        <button className="dialog-btn" type="submit">{state==="edit"?"Update":"Save"}</button>
                    </div>
                </form>
            </div>
        </div >
    );
};
